@if (isLoading) {
  <div class="spinner-container">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

<div class="edit-page-background"></div>
<div class="edit-page-content">

  <div class="claim-edit-header-section grid-container">

    <div class="claim-edit-header-status claim-edit-status"
      data-cy="claim-edit-page-edit-title">Edit
    </div>
    <div class="claim-edit-header-title">Claim <span
    data-cy="claim-edit-page-claim-number">{{claimDetail.number}}</span></div>

    <div class="claim-edit-header-status header-status">
      <span [ngClass]="['header-status', claimDetail.status.code]"
      data-cy="claim-edit-page-claim-status">{{claimDetail.status.code}}</span></div>
    </div>

    @if (statusSchemaView) {
      <app-claim-progress [model]="statusSchemaView"></app-claim-progress>
    }

    <div class="claim-edit-information-section">
      <app-claim-information-form [hasTitle]="true"
        [claimDetail]="claimDetail"
        [editMode]="true"
        (attachmentsHaveChanged)="updateClaimAttachments()"
        (mandatoryFieldsErrors)="informationMandatoryFieldsErrorsMap($event)"
        (updatedClaimInformation)="updateClaimInformation($event)"
        (validForSave)="informationSectionIsValid($event)"
        (isFileManagerOnline)="checkFileManagerIsOnline($event)"
      (isLoading)="headerIsLoading($event)"></app-claim-information-form>
    </div>

    <div class="claim-edit-positions-section">
      <app-material-position-table [positions]="positions"
        [material]="material"
        [claimCodeCode]="claimCode"
        [partnerCode]="partnerCode"
        [supplyingPackingPlantCode]="plantCode"
        [maxNumberOfPositions]="maxNumberOfPositions"
        [showSectionTitle]="true"
        [showMaterialTitle]="false"
        [disableTableButtons]="!enablePositionTableButtons()"
        [dependentFieldParentsErrors]="positionsDependentFieldParentsErrors"
        (isLoading)="manageLoading($event)"
        (isValidForSave)="positionsSectionIsValid($event)"
      [editMode]="true"></app-material-position-table>
    </div>

  </div>
  <div class="edit-page-footer">
    <button type="button" class="btn-text-link" (click)="cancelClick()" data-cy="claim-edit-cancel-button">
      <span class="text">Cancel</span>
    </button>
    <button type="button" class="btn-primary" (click)="saveClick()" [disabled]="!claimCanBeSaved"
      data-cy="claim-edit-save-button">Save
    </button>
  </div>

  <ng-template #tooltip>
    @if (statusSchemaView.justification) {
      <div style="white-space: pre-line;">
        {{statusSchemaView.justification}}
      </div>
    }
  </ng-template>
